import request from '../../utils/request';
import qs from 'qs';

export async function getCsmBlackListListRequest(params) {
  return request({
    url: 'blackList/list',
    method: 'get',
    headers: 'json',
    params,
  });
}

export async function addCsmBlackListRequest(params) {
  return request({
    url: 'blackList/add',
    method: 'post',
    headers: 'json',
    params,
  });
}

export async function removeCsmBlackListRequest(params) {
  return request({
    url: `blackList/remove?${qs.stringify(params)}`,
    method: 'put',
    headers: 'json',
  });
}
